import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function queryMAWBOtherCharge(params) {
  return request({
    url: URL.partner.queryMAWBOtherCharge,
    method: 'get',
    params
  })
}
